import { useQuery } from '@tanstack/react-query';

import { authenticatedBitswanBackendInstance } from '@/lib/api-client';
import type { ProcessingFee } from '@/types/advisor-billing';

export function useProcessingFee() {
  return useQuery<ProcessingFee>({
    queryKey: ['processing-fee'],
    queryFn: async () => {
      const api = await authenticatedBitswanBackendInstance();
      return (await api.get('/advisor/billing/processing-fee/')).data;
    },
    retry: false,
    staleTime: 5 * 60 * 1000,
  });
}
